import React, { useEffect, useState } from 'react'


const useMediaPlayer = () => {

    const [duration, setDuration] = useState<number>();
    const [curTime, setCurTime] = useState<number>();
    const [playing, setPlaying] = useState<boolean>(false);
    const [clickedTime, setClickedTime] = useState<number | null>();
    const [isMuted, setIsMuted] = useState<boolean>(false)

    useEffect(() => {
        const media = document.getElementById("media") as HTMLVideoElement;
    
        if(media) {
          // state setters wrappers
          const setMediaData = () => {
            setDuration(media.duration);
            setCurTime(media.currentTime);
          }

          // Mute or Unmute media
          if(isMuted) {
            media.muted = true
          } else {
            media.muted = false
          }
      
          const setMediaTime = () => {
            setCurTime(media.currentTime)
          };
      
          // DOM listeners: update React state on DOM events
          media.addEventListener("loadeddata", setMediaData);
      
          media.addEventListener("timeupdate", setMediaTime);

      
          // React state listeners: update DOM on React state changes
          playing ? media.play() : media.pause();
      
          if (clickedTime && clickedTime !== curTime) {
            media.currentTime = clickedTime;
            setClickedTime(null);
          } 

          // effect cleanup
          return () => {
            media.removeEventListener("loadeddata", setMediaData);
            media.removeEventListener("timeupdate", setMediaTime);
          }
        }
    });
    
    return {
        curTime,
        duration,
        playing,
        isMuted,
        setPlaying,
        setClickedTime,
        setIsMuted,
    }
}

export default useMediaPlayer
